import { render, staticRenderFns } from "./RecipientSelector.vue?vue&type=template&id=1fcb5871&scoped=true&"
import script from "./RecipientSelector.vue?vue&type=script&lang=js&"
export * from "./RecipientSelector.vue?vue&type=script&lang=js&"
import style0 from "./RecipientSelector.vue?vue&type=style&index=0&id=1fcb5871&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcb5871",
  null
  
)

export default component.exports